<template>
  <div class="vkb-nak-date-picker">
    <!-- linke Seite mit Schließen-Button und Jahr/Monatsauswahl -->
    <div class="vkb-nak-date-picker__input hide-all show-small">
      <input
        :value="inputValue"
        :class="{ 'error': !isValidInput }"
        readonly
        type="text"
        placeholder="DD.MM.YYYY"
        @click="isShowPicker = true"
        @input="(e) => onChangeDate(e)"
        @keydown="validateNumber"
      >
    </div>

    <div class="vkb-nak-date-picker__input hide-all show-medium show-large">
      <input
        :value="inputValue"
        :class="{ 'error': !isValidInput }"
        type="text"
        placeholder="DD.MM.YYYY"
        @click="isShowPicker = true"
        @input="(e) => onChangeDate(e)"
        @keydown="validateNumber"
      >
    </div>

    <div :class="[ 'vkb-nak-date-picker__picker', { 'open': isShowPicker } ]">
      <div class="vkb-nak-date-picker__selections">
        <div
          :class="year === minDate.year() && month === minDate.month() ? 'disabled' : ''"
          class="arrow-button arrow-button--left"
          @click="onClickPrevMonth"
        />

        <div class="select-wrapper select-wrapper--year">
          <select :value="year" class="dropdown block" @change="onSelectYear">
            <option
              v-for="_year in yearOptions"
              :key="_year"
              :value="_year"
            >
              {{ _year }}
            </option>
          </select>
        </div>

        <div class="select-wrapper select-wrapper--month">
          <select :value="month" class="dropdown block" @change="onSelectMonth">
            <option
              v-for="(_month, index) in monthOptions"
              :key="index"
              :value="index"
              :disabled="isValidMonth(index)"
            >
              {{ _month }}
            </option>
          </select>
        </div>

        <div
          :class="year === maxDate.year() && month === maxDate.month() ? 'disabled' : ''"
          class="arrow-button arrow-button--right"
          @click="onClickNextMonth"
        />
      </div>
      <!-- rechte Seite mit Kalender -->
      <div class="vkb-nak-date-picker__calendar">
        <div class="calendar-content">
          <div class="calendar-content__weekdays">
            <div
              v-for="(weekday, index) in weekdays"
              :key="index"
              class="weekday"
            >
              {{ weekday }}
            </div>
          </div>

          <div class="calendar-content__days">
            <div
              v-for="(day, index) in dayOptions"
              :key="index"
              :class="['day', { 'selected': day.selected }, { 'neighbor': day.neighbor }, { 'disabled': day.disabled }]"
              @click="onSelectDate(day)"
            >
              {{ day.value ? day.value : '&nbsp;' }}
            </div>
          </div>
        </div>
      </div>

      <div class="vkb-nak-date-picker__footer">
        <a class="button button-small" @click="onSelectToday">Heute</a>
        <a class="button button-small" @click="onInitDate">Löschen</a>
        <a class="button button-small" @click="isShowPicker = false">Schliessen</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
	name: 'date-picker',
	props: {
    className: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: moment().format('YYYY-MM-DD')
    },
    max: {
      type: String,
      default: moment().format('YYYY-MM-DD')
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data(){
    return{
      monthOptions: moment.months(),
      weekdays: moment.weekdaysMin(true),
      dateContext: moment(),
      dateValue: null,
      inputValue: '',
      isShowPicker: false,
      isValidInput: true
    };
  },

  computed: {
    month: function () {
      return this.dateContext.month();
    },
    year: function () {
      return this.dateContext.year();
    },
    maxDate() {
      return moment(this.max);
    },
    minDate() {
      return moment(this.min);
    },
    selDay: function () {
      if (!this.dateValue) {
        return 0;
      }
      return this.dateValue.date();
    },
    selMonth: function () {
      if (!this.dateValue) {
        return 0;
      }
      return this.dateValue.month();
    },
    selYear: function () {
      if (!this.dateValue) {
        return 0;
      }
      return this.dateValue.year();
    },
    dayOptions: function() {
      const start_day = this.dateContext.clone().startOf('month');
      const end_day = this.dateContext.clone().endOf('month');

      let cur_dates = new Array(moment(start_day).daysInMonth())
        .fill(0)
        .map((_, i) => moment(start_day).add(i, 'days'))
        .map(d => ({ date: d, value: d.get('date'), neighbor: false }));

      let prev_dates_num = !moment(start_day).get('day')
        ? 6
        : moment(start_day).get('day') - 1;

      let prev_dates = new Array(prev_dates_num)
        .fill(0)
        .map((_, i) => moment(start_day).subtract(i + 1, 'days'))
        .reverse()
        .map(d => ({ date: d, value: d.get('date'), neighbor: true }));

      let next_dates_num = (7 - moment(end_day).get('day')) % 7;
      let next_dates = new Array(next_dates_num)
        .fill(0)
        .map((_, i) => moment(end_day).add(i + 1, 'days'))
        .map(d => ({ date: d, value: d.get('date'), neighbor: true }));

      let calendar = [ ...prev_dates, ...cur_dates, ...next_dates ];

      return calendar
        .map(day => ({
            date_object: day.date,
            value: day.value,
            neighbor: day.neighbor,
            disabled: day.date > this.maxDate || day.date < this.minDate,
            selected: !day.neighbor &&
              day.value == this.selDay &&
              this.month == this.selMonth &&
              this.year == this.selYear
          })
        );
    },
    yearOptions: function() {
      return new Array(this.maxDate.year() - this.minDate.year() + 1)
        .fill(0)
        .map((n, i) => this.minDate.year() + i);
    }
  },

  created() {
    if (this.value) {
      this.updateDateValue(this.value);
    } else {
      this.dateContext = moment(this.max);
      this.dateValue = null;
    }
  },

	methods: {
    onClose() {
      this.$emit('close');
    },

    onChangeDate: function(e) {
      let dateString = e.target.value;
      let inputDate = moment(dateString, 'DD.MM.YYYY', true);

      if (
        !inputDate.isValid() ||
        inputDate > this.maxDate ||
        inputDate < this.minDate
      ) {
        this.isValidInput = false;
        this.dateValue = null;
        this.inputValue = dateString;
        return;
      }

      this.updateDateValue(inputDate);

      this.isValidInput = true;
      this.isShowPicker = false;
    },

    onClickPrevMonth() {
      let dateContext_ = moment(this.dateContext);
      let month = dateContext_.get('month');
      let year = dateContext_.get('year');

      month--;

      if (month < 0) {
        if (year > this.minDate.year()) {
          year = year - 1;
          month = 11;
        } else {
          month++;
        }
      }

      dateContext_ = dateContext_.set('month', month);
      dateContext_ = dateContext_.set('year', year);

      this.dateContext = dateContext_;
    },

    onClickNextMonth() {
      let dateContext_ = moment(this.dateContext);
      let month = dateContext_.get('month');
      let year = dateContext_.get('year');

      month++;

      if (month > 11) {
        if (year < this.maxDate.year()) {
          year = year + 1;
          month = 0;
        } else {
          month--;
        }
      }

      dateContext_ = dateContext_.set('month', month);
      dateContext_ = dateContext_.set('year', year);

      this.dateContext = dateContext_;
    },

    onInitDate() {
      this.dateValue = null;
      this.inputValue = '';
      this.isShowPicker = false;
    },

    onSelectToday() {
      this.updateDateValue(moment());
      this.isShowPicker = false;
    },

    onSelectMonth: function(e) {
      let month = parseInt(e.target.value);
      this.dateContext = moment(this.dateContext).set('month', month);

      if (this.dateContext > this.maxDate) {
        this.dateContext = moment(this.maxDate);
      }

      if (this.dateContext < this.minDate) {
        this.dateContext = moment(this.minDate);
      }
    },

    onSelectYear: function(e) {
      let year = parseInt(e.target.value);
      this.dateContext = moment(this.dateContext).set('year', year);

      if (this.dateContext > this.maxDate) {
        this.dateContext = moment(this.maxDate);
      }

      if (this.dateContext < this.minDate) {
        this.dateContext = moment(this.minDate);
      }
    },

    onSelectDate: function(day) {
      if (day.disabled) {
        return;
      }

      this.updateDateValue(day.date_object);
      this.isShowPicker = false;
      this.isValidInput = true;
    },

    updateDateValue(value) {
      this.dateValue = moment(value);
      this.dateContext = this.dateValue.clone();
      this.inputValue = this.dateValue.format('DD.MM.YYYY');
    },

    isValidMonth(month) {
      return (
        (this.year === this.maxDate.year() && month > this.maxDate.month()) ||
        (this.year === this.minDate.year() && month < this.minDate.month())
      );
    },

		validateNumber(evt) {
			if (
        evt.keyCode == 8 ||
        evt.keyCode == 46 ||
        evt.keyCode == 190 ||
        (
          evt.keyCode >= 37 &&
          evt.keyCode <= 40
        )
      ) {
				return true ;
      }

			if (evt.keyCode == 32 || isNaN(evt.key)) {
				evt.preventDefault();
			}
    }
  },

  watch: {
    dateValue() {
      let value = this.dateValue && this.dateValue.isValid()
        ? this.dateValue.format('YYYY-MM-DD')
        : '';

      if (value) {
        this.$emit('select', value);
      }
    },

    value() {
      this.updateDateValue(this.value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/date-picker.vue